import { Link } from 'gatsby-link'
import { GatsbyImage } from 'gatsby-plugin-image'
import React, { useState } from 'react'
import { useLink, useSiteQuery } from '../../../hooks'
import * as styles from './footer.module.scss'
import { RichText } from './../../RichText/RichText'
import PrivacyNotice from '../PrivacyNotice/PrivacyNotice'


const Footer = () => {
    const { headerLogo, footerCopyrightText, address,digitupPrivacyNotice } = useSiteQuery()

    const scrollTo = (id) => {
        if (document.getElementById(`${id}`))
            window.scrollTo({
                top: document.getElementById(`${id}`).offsetTop - 80,
                behavior: "smooth",
            })
    }
    // console.log("slug", slug)
    const [openPrivacyNotice, setOpenPrivacyNotice] = useState(false)

    return (
        <footer className={styles.mainContainer}>
            {
                openPrivacyNotice
                   ? <PrivacyNotice 
                       setter={setOpenPrivacyNotice}
                       />
                       : null
            }
            <div className={`${styles.footerContainer} container container-xl`}>
                <div className={styles.container}>
                    <div className={styles.footerLogo}>
                        <a onClick={e => scrollTo('home-content')}>
                            <div className={styles.headerLogo}>
                                <GatsbyImage
                                    image={headerLogo.gatsbyImageData}
                                    alt={headerLogo.title}
                                />
                            </div>
                        </a>
                    </div>
                    <div className={styles.address}>
                        <RichText content={address} />
                    </div>
                </div>
                <div className={styles.containerOne}>
                    <div className={styles.belowText}>
                        <p>
                            {footerCopyrightText}
                        </p>
                    </div>
                    <div className={ `${styles.privacyNotice} privacyNotice`}>
                    <Link to={`/${useLink(digitupPrivacyNotice.slug)}`}>
                            Privacy Notice
                        </Link>
                    </div>
                </div>
            </div>

        </footer>
    )
}

export default Footer